/**
 * CreditLevelBadge Component
 * Displays a credit level (BRONZE, SILVER, GOLD, PLATINUM) as a colored badge
 */

import { CreditLevel } from '@/types/credit.types';
import styles from './CreditLevelBadge.module.css';

interface CreditLevelBadgeProps {
  level: CreditLevel;
  size?: 'sm' | 'md';
  className?: string;
}

const LEVEL_LABELS: Record<CreditLevel, string> = {
  [CreditLevel.BRONZE]: 'Bronze',
  [CreditLevel.SILVER]: 'Silver',
  [CreditLevel.GOLD]: 'Gold',
  [CreditLevel.PLATINUM]: 'Platinum',
};

const LEVEL_STYLE: Record<CreditLevel, string> = {
  [CreditLevel.BRONZE]: styles.bronze ?? '',
  [CreditLevel.SILVER]: styles.silver ?? '',
  [CreditLevel.GOLD]: styles.gold ?? '',
  [CreditLevel.PLATINUM]: styles.platinum ?? '',
};

export function CreditLevelBadge({
  level,
  size = 'md',
  className = '',
}: CreditLevelBadgeProps) {
  const sizeClass = size === 'sm' ? styles.sm : styles.md;

  return (
    <span
      className={[styles.badge, sizeClass, LEVEL_STYLE[level], className]
        .filter(Boolean)
        .join(' ')}
    >
      {LEVEL_LABELS[level]}
    </span>
  );
}
